// extracted by mini-css-extract-plugin
module.exports = {"w1x6iz75":"w1x6iz75","shtloiu":"shtloiu"};